import React from 'react';
import './Warning.css';

const Warning = ({ title = 'Heads up', children }) => {
  if (!children) return null;

  return (
    <div className="warning">
      <div className="warning__icon">⚠️</div>
      <div>
        <h4>{title}</h4>
        <div className="warning__content">{children}</div>
      </div>
    </div>
  );
};

export default Warning;
